// extracted by mini-css-extract-plugin
export default {"content":"style_content__+RcZ3","contentShift":"style_contentShift__VvKfD"};